import api from '../../infrastructure/config/api';

const BASE_URL = '/api/watchlist-symbols';

export const watchlistService = {
  async search(query) {
    const response = await api.get(`${BASE_URL}/candidates`, { params: { q: query } });
    return response.data?.data || [];
  },
  async list() {
    const response = await api.get(BASE_URL);
    return response.data?.data || [];
  },
  async add(symbol, side, source = 'MANUAL') {
    const response = await api.post(BASE_URL, { symbol, side, source });
    return response.data?.data;
  },
  async remove(symbol) {
    await api.delete(`${BASE_URL}/${encodeURIComponent(symbol)}`);
  },
};
